export default {
    Intro: 'intro',
    Setup: 'setup',
    Signs: 'signs',
    Reflections: 'reflections',
    Summary: 'summary',
};